/**
 * The one Get Customers launch flag (plan L12, A15). Off production it is always on. On production
 * it is off, which only hides the links: no nav entry, no `/get-customers` → `/customers` 301, and
 * the `/get-customers` signup does not return to `/customers`. The `/customers/**` pages are served
 * everywhere.
 * Plain module with no imports so `next.config.ts` can use it. Read the variable literally: Next.js
 * inlines only `process.env.NEXT_PUBLIC_*` into the browser bundle.
 */
export function isCustomersLaunched(): boolean {
  return process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production'
}
